/**
 * This file is shared between pok-core & pok-web
 * If you have to change it then do it in pok-core and run yarn get:validation-schemas @pok-web
 */

// Signature frame on a contract PDF, in PDF points. The preview frame in
// pok-web and the signature drawn by SignPdf are both laid out from these.
export const SignatureFrame = {
  maxPositions: 5,
  widthPt: 180,
  heightPt: 80,
  signatureBoxWidthPt: 80,
  gapPt: 5,
  stampBoxWidthPt: 95,
} as const;
